import { CustomCellEditorProps } from "ag-grid-react";
import { Select } from "antd";

import { useMemo } from "react";

type Props = CustomCellEditorProps & {};

function UserCompanySelectCellEditor(props: Props) {
  const { stopEditing, context, onValueChange } = props;

  const companies = useMemo(() => {
    if (context?.subscriptionCompanies) {
      return context?.subscriptionCompanies?.map((c: any) => {
        return {
          key: c?.id,
          value: c?.name,
          label: c?.name
        };
      });
    }

    if (context?.projectCompanies) {
      return context?.projectCompanies?.map((c: any) => {
        return {
          key: c?.vendor_id,
          value: c?.subscription_vendor?.name,
          label: c?.subscription_vendor?.name
        };
      });
    }

    return [];
  }, [context?.projectCompanies, context?.subscriptionCompanies]);

  return (
    <Select
      open
      allowClear
      optionFilterProp="label"
      virtual={false}
      style={{ width: "100%" }}
      showSearch
      data-testid="usercompanycelleditor-select-company"
      onChange={(event: any) => {
        onValueChange(event);
        setTimeout(() => {
          stopEditing();
        }, 200);
      }}
      options={companies.sort((a: any, b: any) =>
        a.label.localeCompare(b.label)
      )}
    />
  );
}

export default UserCompanySelectCellEditor;
